import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-top: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
`;
